var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { UserRole } from "@irati/identity/enums";
var baseUserDetails = {
    teams: [],
    gender: "F",
    dob: "1992-02-11",
    phone: null,
    profile_img: null,
    address_list: [],
    settings: {}
};
var generateNewUsers = function (jobId, tenantId) {
    var newUserDetails = __assign(__assign({}, baseUserDetails), { email: "user-" + jobId + "@e2e.com", tenant: tenantId, role: UserRole.user, roles: [UserRole.user], firstname: "Basic", lastname: "User" });
    var newManagerDetails = __assign(__assign({}, baseUserDetails), { email: "manager-" + jobId + "@e2e.com", tenant: tenantId, role: UserRole.manager, roles: [UserRole.user, UserRole.manager], firstname: "Manager", lastname: "Man" });
    var newAdminDetails = __assign(__assign({}, baseUserDetails), { email: "admin-" + jobId + "@e2e.com", tenant: tenantId, role: UserRole.admin, roles: [UserRole.user, UserRole.manager, UserRole.admin], firstname: "Admin", lastname: "Ad" });
    var newSuperAdminDetails = __assign(__assign({}, baseUserDetails), { email: "superAdmin-" + jobId + "@e2e.com", tenant: tenantId, role: UserRole.superAdmin, roles: [UserRole.user, UserRole.manager, UserRole.admin, UserRole.superAdmin], firstname: "Super", lastname: "Admin" });
    return [newUserDetails, newManagerDetails, newAdminDetails, newSuperAdminDetails];
};
export default generateNewUsers;
